export const environment = {
 production: true,
 apiBaseUrl: 'https://api.mobile-parking.eu/v9/',
 loginAuthority : 'https://login.apcoaflow.dk/',
 loginRedirectUri: '/signin/?',
 postLogoutRedirectUri: '/?',
 epayMerchantNumber: 5317649,
 epayMD5Secret: 'SecretMD5Key',
 epayCallbackUrl: 'https://api.mobile-parking.eu/providers/epay/ADK/',
 host: 'https://www.apcoaflow.dk',
 mapApiKey: 'AIzaSyCpbrIGomXBrr0e3bc8VFSkyunNuBj8z_s',
 DMRUrl: 'https://dmr.mobilparkering.dk/V1/VehicleRegistration',
 contractUrl: 'https://udlejning.mobilparkering.dk',
 epayCss: 'https://apcoaflow.dk/css/epay.css'
};
